var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChecklist = function SvgChecklist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 58 59"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#7B4EF8",
    clipPath: "url(#checklist_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M22.192 1.565 9.142 14.614 1.146 6.618"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M28.734 10.35h28.21"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M22.192 21.51 9.142 34.56l-7.996-7.997"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M28.734 30.295h28.21M28.734 48.748h28.21"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.073,
    cy: 48.837,
    r: 6.355
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "checklist_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .334h58v58H0z"
  })))));
};
export default SvgChecklist;